<div class="container">
    <div class="main-container-searchform">
        <div class="container-form">
            <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
                <!-- DATE -->
                <div class="column top">
                    <div class="row no-space">
                        <div class="date-label" *ngFor="let dateOption of dateOptions">
                            <input 
                                type="radio"
                                [id]="'dateOption' + dateOption.id"
                                [value]="dateOption.id"
                                formControlName="dateCheckbox"
                                (change)="onDateCheckboxChange(dateOption.id)"
                                />
                                <label [for]="dateOption.id">{{dateOption.label}}</label>
                        </div>
                    </div>
                </div>
                <!-- Specific Date -->
                @if(!dateHidden) {
                    <div class="column top-2" [hidden]="dateHidden">
                        <p-calendar #calendarDate
                            id="date" 
                            formControlName="date" 
                            showButtonBar="true"
                            showClear="true"
                            [showIcon]="true" 
                            [showOnFocus]="true"
                            [readonlyInput]="true" 
                            inputId="searchdate" 
                            [placeholder]="'Specific Date'" 
                            [touchUI]="true"
                            appendTo="body"
                             />
                             <div class=error-row-alt>
                                <div class="helper-text">Dates can be UTC or Local</div>
                            </div>
                    </div>
                }
                <!-- DATE RANGE -->
                 @if (dateHidden) {
                     <div class="column top-2" [hidden]="dateHidden">
                         <p-calendar #calendarRange
                             id="dateRange" 
                             formControlName="dateRange" 
                             selectionMode="range" 
                             showButtonBar="true" 
                             showClear="true"
                             [showIcon]="true"
                             [readonlyInput]="true" 
                             [placeholder]="'Date Range'" 
                             [minDate]="minDate" 
                             [maxDate]="maxDate" 
                             [touchUI]="true"
                             [class.ng-invalid.ng-dirty]="hasDateRangeValidationError()"
                             appendTo="body"/>
                                @if (hasDateRangeValidationError()) {
                                    <div class=error-row-alt>
                                        <div class="error-msg">End Date Required</div>
                                    </div>
                                }
                                @else {
                                    <div class=error-row-alt>
                                        <div class="helper-text">Dates can be UTC or Local</div>
                                    </div>
                                }
                     </div>
                 }
                <!-- SEQUENCE NUMBER -->
                <div class="column">
                    <label for="sequenceNumber">Sequence Number</label>
                    <p-inputNumber
                    inputmode="numeric"
                    pattern="[0-9]*"
                    type="text" 
                    id="sequenceNumber" 
                    formControlName="sequenceNumber" 
                    mode="decimal"
                    inputId="withoutgrouping" 
                    [useGrouping]="false" 
                    maxlength="5" 
                    showClear="true" />
                </div>
                <!-- Station/Airport -->
                <div class="column top">
                    <div class="row">
                        <div class="row no-space">
                            <div class="date-label" *ngFor="let stationOption of stationOptions">
                                <input 
                                    type="radio"
                                    [id]="'stationOption' + stationOption.id"
                                    [value]="stationOption.id"
                                    formControlName="stationCheckbox"
                                    (change)="onStationCheckboxChange(stationOption.id)"/>
                                <label [for]="stationOption.id">{{stationOption.label}}</label>
                            </div>
                        </div>
                        @if(form.get('stationCode')?.value || 
                            form.get('departureStation')?.value || 
                            form.get('arrivalStation')?.value) {
                            <button 
                                class="clear-btn-small" type="button"
                                (click)="onFieldReset('stationCode', ['departureStation', 'arrivalStation'])">
                                <i class="pi pi-times-circle"></i>
                            </button>
                        }
                    </div>
                </div>
                <!-- AIRPORT -->
                    <div [@airport]="animationState">
                        <div class="column top-2 z-4">
                            <p-dropdown 
                                class="station-dropdown"
                                id="stationCode" 
                                formControlName="stationCode" 
                                [options]="airportsList"
                                [filter]="true"
                                autofocusFilter="false"
                                filterBy="stationCode,stationName"
                                optionLabel="stationCode" 
                                placeholder="Airport IATA (DEP or ARR)"
                                [virtualScroll]="true"
                                [virtualScrollItemSize]="40"
                                [class.field-error]="depRouteError()">
                                <ng-template let-airport pTemplate="selectedItem">
                                     <div>{{airport.stationCode}}</div>
                                </ng-template>
                                <ng-template let-airport pTemplate="item">
                                    <div class="dropdown-item">{{airport.stationCode}}: {{airport.stationName}}</div>
                                </ng-template>
                             </p-dropdown>
                             <div class=error-row-alt>
                                <div class="empty-div"></div>
                             </div>
                        </div>
                    </div>
                <!-- ROUTE -->
                    <div [@route]="animationState">
                        <div class="column top-2 z-4" >
                            <div class="row" >
                                <div class="column-alt left">
                                    <div class="row">
                                        <div class="column">
                                            <p-dropdown 
                                                class="station-dropdown"
                                                id="departureStation" 
                                                formControlName="departureStation" 
                                                [options]="airportsList"
                                                [filter]="true"
                                                autofocusFilter="false"
                                                filterBy="stationCode,stationName"
                                                optionLabel="stationCode" 
                                                placeholder="DEP"
                                                [virtualScroll]="true"
                                                [virtualScrollItemSize]="40"
                                                [class.field-error]="depRouteError()"
                                                >
                                            <ng-template let-airport pTemplate="selectedItem">
                                                <div>{{airport.stationCode}}</div>
                                            </ng-template>
                                            <ng-template let-airport pTemplate="item">
                                                <div class="dropdown-item">{{airport.stationCode}}: {{airport.stationName}}</div>
                                            </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                     @if (depRouteError()) {
                                        <div class=error-row-alt>
                                            <div class="error-msg">Departure Airport Required</div>
                                        </div>
                                     }
                                     @else {
                                        <div class=error-row-alt>
                                            <div class="empty-div"></div>
                                        </div>
                                     }
                                 </div>
                                 <div class="column-alt right">
                                     <div class="row">
                                         <div class="column">
                                            <p-dropdown 
                                                class="station-dropdown"
                                                id="arrivalStation" 
                                                formControlName="arrivalStation" 
                                                [options]="airportsList"
                                                [filter]="true"
                                                autofocusFilter="false"
                                                filterBy="stationCode,stationName"
                                                optionLabel="stationCode" 
                                                placeholder="ARR"
                                                [virtualScroll]="true"
                                                [virtualScrollItemSize]="40"
                                                [class.field-error]="arrRouteError()">
                                            <ng-template let-airport pTemplate="selectedItem">
                                                <div>{{airport.stationCode}}</div>
                                            </ng-template>
                                            <ng-template let-airport pTemplate="item">
                                                <div class="dropdown-item">{{airport.stationCode}}: {{airport.stationName}}</div>
                                            </ng-template>
                                            </p-dropdown>
                                         </div>
                                     </div>
                                     @if (arrRouteError()) {
                                         <div class=error-row-alt>
                                             <div class="error-msg">Arrival Airport Required</div>
                                         </div>
                                     }
                                     @else {
                                         <div class=error-row-alt>
                                             <div class="empty-div"></div>
                                         </div>
                                     }
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- EQUIPMENT -->
                <div class="row">
                    <!-- TYPE -->
                    <div class="column-alt left">
                        <div class="row">
                            <label for="equipmentNumber">Equipment</label>
                            @if(form.get('equipmentNumber')?.value) {
                                <button class="clear-btn-small" type="button" (click)="onFieldReset('equipmentNumber')">
                                    <i class="pi pi-times-circle"></i>
                                </button>
                            }
                        </div>

                        <p-dropdown 
                            id="equipmentNumber" 
                            formControlName="equipmentNumber" 
                            [options]="equipmentNumbers"
                            [filter]="true"
                            autofocusFilter="false"
                            filterBy="EQ,long"
                            optionLabel="long" 
                            placeholder="Select"
                            >
                            <ng-template let-item pTemplate="selectedItem">
                                <div>{{item.long}}</div>
                            </ng-template>
                            <ng-template let-aircraft pTemplate="item">
                                <div>EQ{{aircraft.EQ}}: {{aircraft.long}}</div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                    <!-- NOSE NUMBER -->
                    <div class="column-alt right">
                        <div class="row">
                            <label for="equipmentReg">Equip. Nose#</label>
                            @if(form.get('equipmentReg')?.value) {
                                <button class="clear-btn-small" type="button" (click)="onFieldReset('equipmentReg')">
                                    <i class="pi pi-times-circle"></i>
                                </button>
                            }
                        </div>
                        <input id="equipmentReg" formControlName="equipmentReg" type="text" placeholder="Nxxx"
                            pInputText style="text-transform: uppercase;" maxlength="4"
                            (keypress)="validateKeyPress($event)"
                            (focusin)="addPrefix()"
                            (focusout)="removePrefix()"/>
                    </div>
                </div>
                <!-- SEAT POSITION / FLT # -->
                <div class="row">
                    <div class="column-alt left top">
                        <div class="row">
                            <label for="seatPosition">Seat</label>
                            @if(form.get('seatPosition')?.value) {
                                <button class="clear-btn-small" type="button" (click)="onFieldReset('seatPosition')">
                                    <i class="pi pi-times-circle"></i>
                                </button>
                            }
                        </div>
                        <p-dropdown id="seatPosition" formControlName="seatPosition" [options]="seatPositions"
                            placeholder="Select"></p-dropdown>
                    </div>
                    <div class="column-alt right top">
                        <div class="row">
                            <label for="flightNumber">Flight Number</label>
                            @if(form.get('flightNumber')?.value) {
                                <button class="clear-btn-small" type="button" (click)="onFieldReset('flightNumber')">
                                    <i class="pi pi-times-circle"></i>
                                </button>
                            }
                        </div>
                        <input
                            inputmode="numeric"
                            pattern="[0-9]*"
                            type="text" 
                            pInputText id="flightNumber" 
                            formControlName="flightNumber" 
                            inputId="withoutgrouping" 
                            maxlength="4" 
                            (input)="numeric(form.controls.flightNumber)"
                            placeholder="1234" />
                    </div>
                </div>
                <!-- CREW -->
                <div class="column top">
                    <label>Flight Crew Member</label>
                    <div class="row">
                        <div class="column-alt left top">
                            <div class="row">
                                <label for="firstName">First Name</label>
                                @if(form.get('firstName')?.value) {
                                    <button class="clear-btn-small" type="button" (click)="onFieldReset('firstName')">
                                        <i class="pi pi-times-circle"></i>
                                    </button>
                                }
                            </div>
                            <input pInputText id="firstName" formControlName="firstName" type="text" />
                            <div class=error-row-alt>
                                <div class="empty-div"></div>
                            </div>
                        </div>
                        
                        <div class="column-alt right top">
                            <div class="row">
                                <label for="lastName">Last Name</label>
                                @if(form.get('lastName')?.value) {
                                    <button class="clear-btn-small" type="button" (click)="onFieldReset('lastName')">
                                        <i class="pi pi-times-circle"></i>
                                    </button>
                                }
                            </div>
                            <input pInputText id="lastName" formControlName="lastName" type="text"
                                [class.field-error]="hasLastNameRequiredError()" />
                                @if (hasLastNameRequiredError()) {
                                    <div class=error-row-alt>
                                        <div class="error-msg">Last Name required.</div>
                                    </div>
                                }
                                @else {
                                    <div class=error-row-alt>
                                        <div class="empty-div"></div>
                                    </div>
                                }
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="row">
                        <label for="employeeNumber">Employee Number</label>
                        @if(form.get('employeeNumber')?.value) {
                            <button class="clear-btn-small" type="button" (click)="onFieldReset('employeeNumber')">
                                <i class="pi pi-times-circle"></i>
                            </button>
                        }
                    </div>
                    <input 
                        pInputText 
                        inputmode="numeric"
                        pattern="[0-9]*"
                        type="text" 
                        id="employeeNumber" 
                        formControlName="employeeNumber" 
                        maxlength="6"
                        (input)="numeric(form.controls.employeeNumber)"
                        [class.field-error]="empNumNaNError() || hasMatchingEmpNumError() && form.invalid" />
                </div>
                @if ( empNumNaNError() ) {
                    <div class=error-row-alt>
                        <div class="error-msg">Error, invalid input.</div>
                    </div>
                    }
                @else if (hasMatchingEmpNumError()) {
                    <div class=error-row-alt>
                        <div class="error-msg">Cannot search user Employee Number</div>
                    </div>
                }
                @else {
                    <div class=error-row-alt>
                        <div class="empty-div"></div>
                    </div>
                }
            </form>
        </div>
    </div>
    <div class="button-container" *ngIf="appService.theme$ | async as theme">
        <div class="row-btn">
            <button class="reset-btn" pButton pRipple type="button" [disabled]="!form.valid"
                (click)="onReset()"
                [style]="{
                    'background': theme === 'light' ? 'var(--button-primary)' : 'transparent',
                    'color' : theme === 'light' ? 'var(--surface-0)' : 'var(--button-primary)'}">
                Reset
            </button>
            <button class="search-btn" pButton pRipple type="submit" [disabled]="form.invalid"
            (click)="onSubmit()"
            [style]="{
                'background': theme === 'light' ? 'var(--button-primary)' : 'transparent',
                'color' : theme === 'light' ? 'var(--surface-0)' : 'var(--button-primary)'}">
                Search
            </button>
        </div>
    </div>
</div>

<!-- Code if using input fields for airport and route iso dropdowns -->

<!-- Airport -->
<!-- <input pInputText 
        id="stationCode" 
        formControlName="stationCode" 
        type="text"
        placeholder="Airport IATA (DEP or ARR)"
        style="text-transform: uppercase;" 
        maxlength="3"
        (input)="alphaChar(form.controls.stationCode)"/>
        <div class=error-row-alt>
            <div class="empty-div"></div>
        </div> -->

<!-- Route Dep -->
<!-- <input pInputText 
        id="departureStation" 
        formControlName="departureStation" 
        type="text"
        placeholder="DEP"
        style="text-transform: uppercase;" 
        maxlength="3"
        (input)="alphaChar(form.controls.departureStation)"
        [class.field-error]="depRouteError()"/> -->

<!-- Route Arr -->
 <!-- <input pInputText 
        id="arrivalStation" 
        formControlName="arrivalStation" 
        type="text"
        placeholder="ARR"
        style="text-transform: uppercase;" 
        maxlength="3"
        showClear="true"
        (input)="alphaChar(form.controls.arrivalStation)"
        [class.field-error]="arrRouteError()"/> -->
